import type { PriceListMtrRowData } from 'gql/graphql';

import { Checkbox } from '@consta/uikit/Checkbox';

interface ICellRenderCheckbox {
    checkedIds: Record<string, boolean>;
    handleChangeCheckbox: (
        rowId: number,
        isHeadCheckbox?: boolean,
    ) => (args: { e: React.ChangeEvent<HTMLInputElement>; checked: boolean }) => void;
    data: PriceListMtrRowData;
    isHeadCheckbox?: boolean;
    isAllRowChecked?: boolean;
    checkedCount?: number;
    hasDataItems?: boolean;
}

export const CellRenderCheckbox = (props: ICellRenderCheckbox) => {
    const { checkedIds, handleChangeCheckbox, data, isHeadCheckbox, isAllRowChecked, checkedCount, hasDataItems } =
        props;

    if ((!data?.code && !isHeadCheckbox) || (!hasDataItems && isHeadCheckbox)) {
        return null;
    }

    return (
        <div>
            <Checkbox
                className="CheckboxFocus"
                checked={isHeadCheckbox ? isAllRowChecked : checkedIds[data?.id]}
                onChange={handleChangeCheckbox(data?.id, isHeadCheckbox)}
                intermediate={isHeadCheckbox && !isAllRowChecked && !!checkedCount}
                style={{ marginTop: 4 }}
            />
        </div>
    );
};

CellRenderCheckbox.displayName = 'CellRenderCheckbox';
